var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("system", { attrs: { leftList: _vm.leftList } }),
      _vm._v(" "),
      _c("div", { staticClass: "pageBox" }, [
        _c(
          "div",
          { staticClass: "breadcrumb" },
          [
            _c(
              "el-breadcrumb",
              { attrs: { separator: "/" } },
              [
                _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                  _vm._v("首页"),
                ]),
                _vm._v(" "),
                _c("el-breadcrumb-item", [_vm._v("供应商管理")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageTabAdd" },
          [
            _c(
              "el-card",
              { staticClass: "box-card" },
              [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("el-page-header", {
                      attrs: { content: _vm.title },
                      on: { back: _vm.goBack },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    ref: "ruleForm",
                    staticClass: "demo-ruleForm",
                    attrs: {
                      "label-position": "right",
                      model: _vm.ruleForm1,
                      rules: _vm.rules,
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "供应商名称", prop: "name" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入供应商名称" },
                          model: {
                            value: _vm.ruleForm1.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm1, "name", $$v)
                            },
                            expression: "ruleForm1.name",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "服务地址", prop: "url" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入服务地址" },
                          model: {
                            value: _vm.ruleForm1.url,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm1, "url", $$v)
                            },
                            expression: "ruleForm1.url",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "服务分类", prop: "type" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { "margin-right": "auto" },
                            attrs: { placeholder: "请选择" },
                            model: {
                              value: _vm.ruleForm1.type,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm1, "type", $$v)
                              },
                              expression: "ruleForm1.type",
                            },
                          },
                          _vm._l(_vm.options, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: {
                                label: item.name,
                                value: item.creatorId,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "服务省", prop: "type1" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { "margin-right": "auto" },
                            attrs: { placeholder: "请选择" },
                            on: { change: _vm.cityChange },
                            model: {
                              value: _vm.ruleForm1.type1,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm1, "type1", $$v)
                              },
                              expression: "ruleForm1.type1",
                            },
                          },
                          _vm._l(_vm.city, function (item, index) {
                            return _c("el-option", {
                              key: item.adcode,
                              attrs: { label: item.name, value: item.adcode },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.ruleForm1.type1 != "100000"
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "服务城市", prop: "select" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { "margin-right": "auto" },
                                attrs: { placeholder: "请选择" },
                                on: { change: _vm.cityChange1 },
                                model: {
                                  value: _vm.ruleForm1.select,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm1, "select", $$v)
                                  },
                                  expression: "ruleForm1.select",
                                },
                              },
                              _vm._l(_vm.city1, function (item, index) {
                                return _c("el-option", {
                                  key: item.adcode,
                                  attrs: {
                                    label: item.name,
                                    value: item.adcode,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.ruleForm1.type1 != "100000"
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "服务地区", prop: "send" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { "margin-right": "auto" },
                                attrs: { placeholder: "请选择" },
                                model: {
                                  value: _vm.ruleForm1.send,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm1, "send", $$v)
                                  },
                                  expression: "ruleForm1.send",
                                },
                              },
                              _vm._l(_vm.city2, function (item, index) {
                                return _c("el-option", {
                                  key: item.adcode,
                                  attrs: {
                                    label: item.name,
                                    value: item.adcode,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "公司地址", prop: "address" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入公司地址" },
                          model: {
                            value: _vm.ruleForm1.address,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm1, "address", $$v)
                            },
                            expression: "ruleForm1.address",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "客服电话", prop: "tel" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入客服电话" },
                          model: {
                            value: _vm.ruleForm1.tel,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm1, "tel", $$v)
                            },
                            expression: "ruleForm1.tel",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "微信公众号", prop: "weixin" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入微信公众号" },
                          model: {
                            value: _vm.ruleForm1.weixin,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm1, "weixin", $$v)
                            },
                            expression: "ruleForm1.weixin",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.resetForm1("ruleForm")
                              },
                            },
                          },
                          [_vm._v("取消")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-right": "auto" },
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.submitForm("ruleForm")
                              },
                            },
                          },
                          [_vm._v("确定")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }